import { Component } from "../components/index"
import { qsa, qs } from "../utils/index"

export default class ProductVideo extends Component {
  constructor(obj) {
    super(obj)
  }
}
